<form [formGroup]="form" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <!--<button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>-->
            <button [disabled]="!habilitarGuardar" class="btn btn-outline-success" type="button" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo Documento </button>
            <button *ngIf="isInspector" [disabled]="!habilitarNuevoSeguimiento" class="btn btn-outline-success" (click)="onAddSeguimiento()"><i class="fa fa-file-o"></i> Nuevo Seguimiento</button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4 style="display:inline">Documentos {{solicitudDocumentoEx.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />-->
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <!--<label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudEx}}">{{solicitudDocumentoEx.CodigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{solicitudDocumentoEx.IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudDocumentoEx.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{solicitudDocumentoEx.IdEstadoSolicitudExDescripcion}}" />
                <img *ngIf="solicitudDocumentoEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || solicitudDocumentoEx?.IdSubTipoSolicitudEx === reExpConAtestFito || solicitudDocumentoEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{solicitudDocumentoEx.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{solicitudDocumentoEx.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudDocumentoEx.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{solicitudDocumentoEx.IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="solicitudDocumentoEx?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{solicitudDocumentoEx.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudDocumentoEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>
        <!--DOCUMENTOS-->
        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="card card-accent-success">

                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Documentos
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="documentosEstandar"
                                 [columns]="cols" sortField="Fecha" sortOrder="-1"
                                 styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                 [ngClass]="displayGridHidden(documentosEstandar)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                <tr>

                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">

                                        <span *ngIf="(col.field!=='Link' && col.field!=='Fecha' && col.field!=='Attached' && col.field!=='Autogenerado')">
                                            {{rowData[col.field]}}
                                        </span>

                                        <span *ngIf="col.field==='Fecha'">
                                            {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                        </span>


                                        <div *ngIf="col.field==='Link'">

                                            <span *ngIf="documentoDescargable">
                                                <button (click)="onDownload(rowData)" type="button" title="Descargar documento"
                                                        class="btn btn-sm btn-danger">
                                                    <span class="fa fa-download"></span>
                                                </button>
                                            </span>

                                            <span *ngIf="isDocumentoEditable(rowData) && ((!isInspector && !rowData['SubidoPorInspector']) || isInspector)">
                                                <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                        class="btn btn-sm btn-warning">
                                                    <span class="fa fa-edit"></span>

                                                </button>
                                            </span>

                                            <span *ngIf="!isDocumentoEditable(rowData) || (!isInspector && rowData['SubidoPorInspector'])">
                                                <button (click)="onEdit(rowData)" type="button" title="Ver"
                                                        class="btn btn-sm btn-info">
                                                    <span class="fa fa-search"></span>

                                                </button>
                                            </span>

                                            <span *ngIf="isDocumentoBorrable(rowData)">
                                                <button [disabled]="rowData['SubidoPorInspector'] && !isInspector" (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                        class="btn btn-sm btn-danger">
                                                    <span class="fa fa-remove"></span>

                                                </button>
                                            </span>
                                            

                                            <span class="float-right" *ngIf="isTracesInfoVisible(rowData, 'Autogenerado')">
                                                <img class="estado-icono" src="{{ (rowData['Autogenerado'] | IconoDocumentoExTraces:['Autogenerado', rowData['EsEphyto']])[0]}}"
                                                     container="body" ngbTooltip="{{ (rowData['Autogenerado'] | IconoDocumentoExTraces:['Autogenerado', rowData['EsEphyto']])[1]}}" />
                                            </span>

                                            <span class="float-right" *ngIf="isTracesInfoVisible(rowData, 'AttachedEphyto')">
                                                <img class="estado-icono" src="{{ (rowData['AttachedEphyto'] | IconoDocumentoExTraces:['AttachedEphyto', rowData['EsEphyto']])[0]}}"
                                                     container="body" ngbTooltip="{{ (rowData['AttachedEphyto'] | IconoDocumentoExTraces:['AttachedEphyto'])[1]}}" />
                                            </span>

                                            <span class="float-right" *ngIf="isTracesInfoVisible(rowData, 'Autogenerado')">
                                                <!-- @author jlht Las copias de CF tienen iconos de estado diferentes al CF original. Distinguir qué pipe pintará el icono en función de si es o no copia el documento -->                                                
                                                <img class="estado-icono" *ngIf="rowData['IdCopia'] === null" src="{{ rowData['IdEstadoCertificadoFitoEx'] | IconoEstadoCertificadoFitoEx}}"
                                                     ngbTooltip="{{rowData['IdEstadoCertificadoFitoExDescripcion']}}" />
                                                <img class="estado-icono" *ngIf="rowData['IdCopia'] > 0" src="{{ rowData['IdEstadoCertificadoFitoEx'] | IconoCopiaCertificadoEx}}"
                                                     ngbTooltip="{{rowData['IdEstadoCertificadoFitoExDescripcion']}}" />
                                            </span>

                                        </div>
                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>
                        <div *ngIf="numeroDocumentos === 0 || allDocumentosAlegacion" class="empty-grid">
                            No hay documentos asociados a la solicitud
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
